import { useState, useEffect } 	from "react";
import { Box, Grid, Paper, Typography } from "@mui/material"

import useFetch 				from '../../api/api'

import DashboardContext 		from "./context";

import PortfolioHistory	 		from "../../components/PortfolioHistory";
import PortfolioHistoryByAsset 	from "../../components/PortfolioHistoryByAsset";
import SummaryCard 				from "./components/SummaryCard";
import AssetSummaryCard 		from "./components/AssetSummaryCard";
import AssetListCard 			from "./components/AssetListCard";
import DividendsCard 			from "./components/DividendsCard";
import LastUpdatesCard 			from "./components/LastUpdatesCard";
import config 					from "../../common/Config";
import useAuth 					from "../../hooks/useAuth";

const Dashboard = () => {
	const privateFetch 						= useFetch();

	const [portfolio, setPortfolio] 		= useState();
	const [dividends, setDividends]			= useState();
	const [exchangeRates, setExchangeRates]	= useState()

	const auth	= useAuth();

	
	useEffect(() => {
		retrieveData()

		// Seta o intervalo de atualizacao porque o servidor desliga apos as 19
		setInterval(() => {
				const currentHour = new Date().getHours()
				const currentDay 	= new Date().getDay()
				if ( currentDay > 0 && currentDay < 6 && currentHour > 7 && currentHour < 19 ) {
					retrieveData()
				}		 		
			}, 10 * 60 * 1000
		 );
	}, [])

	const retrieveData = () => {
		// Retrieve user portfolio
		privateFetch(config.apiUrl +"/api/portfolio/summary")
		.then((data) => data.json())
		.then(async (data) => {

			let url;

			// Retrieve quotes for STOCKS and ACOES
			const stocksQuotes = await privateFetch(config.apiUrl +'/api/quotes/stock')
			.then(quotes => quotes.json())
			.then(quotes => quotes.data)

			const acoesQuotes = await privateFetch(config.apiUrl +'/api/quotes/acao')
			.then(quotes => quotes.json())
			.then(quotes => quotes.data)
			
			const stockAndAcoesQuotes = stocksQuotes.concat(acoesQuotes)

			// Retrieve quotes for BONDS and TESOURODIRETO
			url = config.apiUrl +'/api/bonds/rates/'+ new Date().toISOString().substring(0,10)
			const bondsQuotes = await privateFetch(url).then(data => data.json())

			// Retrieve BDR quotes. 
			const fullQuotes = await privateFetch(config.apiUrl +'/api/quotes/bdr')
			.then(quotes => quotes.json())
			.then(quotes => stockAndAcoesQuotes.concat(quotes.data))

			// Retrieve FIIs quotes.
			const fiiQuotes = await privateFetch(config.apiUrl +'/api/quotes/fii')
			.then(quotes => quotes.json())
			.then(quotes => quotes.data)	

			// Retrieve exchanges quotes. 
			const exchangeQuotes = await privateFetch(config.apiUrl +'/api/quotes/exchange')
			.then(quotes => quotes.json())
			.then(quotes => quotes.data)

			// Retrieve user earnings
			const userEarnings = await privateFetch(config.apiUrl +"/api/portfolio/dividends/ltm")
			.then(async data => await data.json())

			data.map(asset => {

				let currentQuote;
				let currentExchangeRate		= exchangeQuotes.find(q => q.symbol === 'USDBRL') || { price: 1, changesPercent: 0};
				let currentDividends;

				switch (asset.assetType) {
					case 'ACAO' :
						currentQuote		= fullQuotes.find(q => q.symbol === asset.identificator +'.SA') 			
						asset.price			= currentQuote?.price ? currentQuote.price : 0;
						asset.changePercent	= currentQuote?.changesPercentage ? currentQuote.changesPercentage : 0;
						asset.currentValue 	= asset.quantity * asset.price; 

						currentDividends	= userEarnings.filter(e => e.stockTicker === asset.identificator)
						asset.dividends		= currentDividends ? currentDividends.reduce((acc, e) => acc + parseFloat(e.earnings),0) : 0
						break;
					case 'STOCK' :
						currentQuote		= fullQuotes.find(q => q.symbol === asset.identificator)
						asset.price			= currentQuote?.price ? currentQuote.price * currentExchangeRate.price : 0;
						asset.changePercent	= currentQuote?.changesPercentage ? currentQuote?.changesPercentage : 0 
						asset.currentValue 	= asset.quantity * asset.price; 
						asset.cost 			= asset.cost * currentExchangeRate.price; 

						currentDividends	= userEarnings.filter(e => e.stockTicker === asset.identificator)
						asset.dividends		= currentDividends ? currentDividends.reduce((acc, e) => acc + parseFloat(e.earnings),0) * currentExchangeRate.price : 0
						break;
					case 'FII' :
						currentQuote		= fiiQuotes.find(q => q.symbol === asset.identificator)
						asset.price			= currentQuote?.price ? currentQuote.price : 0;
						asset.currentValue 	= asset.quantity * asset.price;
						asset.changePercent	= currentQuote?.changesPercentage
						break;
					case 'TESOURODIRETO': 	
						currentQuote		= bondsQuotes.find(q => q.symbol === asset.identificator)
						asset.price			= currentQuote?.price ? currentQuote.price : 0;
						asset.currentValue 	= asset.quantity * asset.price;
						asset.changePercent	= currentQuote?.changesPercentage ? currentQuote.changesPercentage : 0 
						break;
					case 'BOND' : 
						currentQuote		= bondsQuotes.find(q => q.symbol === asset.identificator)
						asset.price			= currentQuote?.price ? currentQuote.price * currentExchangeRate.price : 0;
						asset.currentValue 	= asset.quantity * asset.price; 
						asset.cost			= asset.cost * currentExchangeRate.price; 	
						asset.changePercent	= currentQuote?.changesPercentage ? currentQuote.changesPercentage : 0 
						break; 
					case 'CASH' :
						currentExchangeRate	= exchangeQuotes.find(q => q.symbol === asset.currency + 'BRL') || { price: 1, changesPercentage: 0}
						asset.price			= currentExchangeRate.price
						asset.currentValue 	= asset.quantity * asset.price; 
						asset.changePercent = currentExchangeRate.changesPercentage
						break
					case 'BANKSAVINGS' : 
						currentExchangeRate	= exchangeQuotes.find(q => q.symbol === asset.currency + 'BRL') || { price: 1, changesPercentage: 0}
						asset.assetType		= 'CASH' // Agrupa Dinheiro e Contas Bancárias
						asset.price			= currentExchangeRate.price
						asset.currentValue 	= asset.quantity * asset.price;
						asset.changePercent = currentExchangeRate.changesPercentage
						asset.cost 			= asset.cost * asset.price; 
						break;
				}
				
				asset.avgPrice				= asset.cost/asset.quantity
				asset.return				= ((asset.price/asset.avgPrice) - 1) * 100
			})

			setPortfolio(data)
			setDividends(userEarnings)
			setExchangeRates(exchangeQuotes)
		})
	}

	return (
		<DashboardContext.Provider value={{portfolio: portfolio, dividends: dividends, exchangeRates: exchangeRates}}>
			<Box margin={2}>
				<Grid container spacing={1}>
					<Grid item xs={12} lg={2}><SummaryCard /></Grid>
					<Grid item xs={12} lg={5}><AssetSummaryCard/></Grid>
					<Grid item xs={12} lg={3}><DividendsCard/></Grid>
					<Grid item xs={12} lg={2}><LastUpdatesCard/></Grid>

					<Grid item xs={12} md={12} lg={6}>
						<Paper elevation={2}>
							<Typography sx={{marginLeft: 3, paddingTop: 2, fontWeight: 'bold'}}>Evolução do Portfólio</Typography>
							<PortfolioHistory/>
						</Paper>
					</Grid>
					<Grid item xs={12} md={12} lg={6}>
						<Paper elevation={2}>
							<Typography sx={{marginLeft: 3, paddingTop: 2, fontWeight: 'bold'}}>Evolução da Composição do Portfólio</Typography>
							<PortfolioHistoryByAsset/>
						</Paper>
					</Grid>

					<Grid item xs={12} md={6}><AssetListCard title="Ações" assetType="ACAO"/></Grid>
					<Grid item xs={12} md={6}><AssetListCard title="Stocks" assetType="STOCK"/></Grid>
					
					{ auth.auth.userId < 50 && (
						<>
						<Grid item xs={12} md={6}><AssetListCard title="FIIs" assetType="FII"/></Grid>
						<Grid item xs={12} md={6}><AssetListCard title="Bonds" assetType="BOND"/></Grid>
						<Grid item xs={12} md={12}><AssetListCard title="Títulos do Tesouro" assetType="TESOURODIRETO"/></Grid>
						<Grid item xs={12} md={12}><AssetListCard assetType="CASH"/></Grid>
						</>
					)}
					
				</Grid>				
			</Box>
		</DashboardContext.Provider>
	)
}

export default Dashboard